import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api, socket } from 'api';
import { GrayButton } from 'libs/ui';
import BskForm from './bsk-form';
import { BskConfirm } from './bsk-confirm';
import { Content } from './add-bsk.styled';

let timer1;
let bskPressed = false;
const errorTimeout = 60000;

export const AddBsk = (props) => {
  const { id } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [bskform, setBskform] = useState(false);
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState({});
  const [card, setCard] = useState('');

  // clean and get card number
  useEffect(() => {
    let _mounted = true;

    /**
     * update card
     * @param {*} msg 
     */
    const updateCard = (msg) => {
      if (loading) {
        if (timer1) {
          clearTimeout(timer1);
        }
        if (_mounted && bskPressed) {
          setBskform(true);
          setLoading(false);
          setErrors({});
          setCard(msg.card_id);
        }
      }
    };

    window.socket.on('dispense_card', updateCard);

    return () => {
      _mounted = false;
      window.socket.off('dispense_card', updateCard);
      if (timer1) {
        clearTimeout(timer1);
      }
    };
  }, []);

  /**
   * show confirm
   * @returns
   */
  const showConfirm = () => {
    if (loading) {
      return;
    }
    setConfirm(true);
  };

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(false);
  };

  /**
   * show bsk form
   */
  const showBskForm = () => {
    if (loading) {
      return;
    }

    if (timer1) {
      clearTimeout(timer1);
    }

    // hide
    if (bskform) {
      setError({});
      setBskform(false);
      setConfirm(false);
      return;
    }

    // start
    setLoading(true);
    setConfirm(false);
    const msg = {
      target: id,
    };
    socket.call('dispense_card', msg);
    bskPressed = true;
    timer1 = setTimeout(() => {
      bskPressed = false;
      setError(true);
      setLoading(false);
    }, errorTimeout);
  };

  /**
   * close bsk form
   */
  const closeBsk = () => {
    setBskform(false);
    setErrors({});
  };

  /**
   * add bsk
   * @param {*} data
   * @returns
   */
  const addBsk = async (data) => {
    if (loading) {
      return;
    }

    setLoading(true);
    const params = Object.assign({}, data);
    if (params.vehicle_class) {
      if (params.vehicle_class === '-1') {
        params.vehicle_class = null;
      } else {
        params.vehicle_class = parseInt(params.vehicle_class, 0);
      }
    }
    if (params.vehicle_category) {
      if (params.vehicle_category === '-1') {
        params.vehicle_category = null;
      } else {
        params.vehicle_category = parseInt(params.vehicle_category, 0);
      }
    }
    params.is_blocked = params.is_blocked === 'true';

    return await api
      .call('subscriptions.add', params)
      .then((data) => {
        if (data.error) {
          setLoading(false);
          setErrors(data?.error?.data);
        } else {
          setBskform(false);
          setErrors({});
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
        setErrors({});
      });
  };

  return (
    <Content>
      <GrayButton className={loading ? 'loading' : ''} onClick={showConfirm}>
        {t('buttons.Выдать БСК')}
      </GrayButton>

      {confirm && <BskConfirm cancel={closeConfirm} ok={showBskForm} />}

      {error && <BskConfirm cancel={closeConfirm} error={true} />}

      {bskform && <BskForm errors={errors} loading={loading} id={id} card={card} close={closeBsk} action={addBsk} />}
    </Content>
  );
};
